import React, { PureComponent } from 'react';

import './styles.css';

export default class ComponentError extends PureComponent {
  render() {
    return (
      <div className="component-error-root">
        <div className="content">
          <div className="message-container">
            <label>Ops!!! Alguma coisa ocorreu em nossos servidores.</label>
          </div>
        </div>
      </div>
    );
  }
}
